"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTrekIdFromUrl = exports.getUserIdFromUrl = exports.getLodgeIdFromUrl = void 0;

var getLodgeIdFromUrl = function getLodgeIdFromUrl() {
  return window.location.pathname.split('/').filter(function (x) {
    return !!x;
  })[0].split('.')[1];
};

exports.getLodgeIdFromUrl = getLodgeIdFromUrl;

var getUserIdFromUrl = function getUserIdFromUrl() {
  var pathname = window.location.pathname;

  if (pathname.startsWith('/guides')) {
    return pathname.split('/')[2].split('.')[1];
  }

  return pathname.split('/')[1].split('.')[1];
};

exports.getUserIdFromUrl = getUserIdFromUrl;

var getTrekIdFromUrl = function getTrekIdFromUrl() {
  return window.location.pathname.split('/').filter(function (x) {
    return !!x;
  })[1].split('.')[1];
};

exports.getTrekIdFromUrl = getTrekIdFromUrl;